module.exports = __webpack_public_path__ + "img/DE02293.7ca1073d.png";